import { useAuth } from '@/contexts/AuthContext'

export type TeamSummary = {
  /** Whether this account belongs to a team at all. */
  inTeam: boolean
  /** Whether this account holds the licence (can invite and remove people). */
  isOwner: boolean
  teamId: number | null
  teamName: string
}

/**
 * Team membership as carried on `/accounts/me/`. The shell uses this to decide
 * whether the Zespół section exists; the panel fetches the full payload itself.
 */
export function useTeam(): TeamSummary {
  const { user } = useAuth()
  const team = user?.team ?? null
  return {
    inTeam: team !== null,
    isOwner: team?.role === 'owner',
    teamId: team?.id ?? null,
    teamName: team?.name ?? '',
  }
}
